import SrRadio from "./SrRadio.vue";

SrRadio.install = function(Vue) {
  Vue.component(SrRadio.name, SrRadio);
};

export default SrRadio;


// WEBPACK FOOTER //
// ./packages/SrRadio/index.js